import statuses from './index.js';

/* istanbul ignore next line */
const SET_LOADING_ADJUSTMENTS = (state, loadingAdjustments) => {
  state.loadingAdjustments = loadingAdjustments
};

const SET_ADJUSTMENTS = (state, adjustments) => {
  state.adjustments = adjustments;
};

const REMOVE_ADJUSTMENT = (state, index) =>{
  state.adjustments.splice(index,1);
}

export default {
  SET_LOADING_ADJUSTMENTS,
  SET_ADJUSTMENTS,
  REMOVE_ADJUSTMENT
};
